const dropdown_toggles = document.querySelectorAll('.js-dropdown-toggle')

for (const dropdown_toggle of dropdown_toggles) {
    dropdown_toggle.addEventListener('click', () => {
        dropdown_toggle.classList.toggle('open')
        dropdown_toggle.nextElementSibling.classList.toggle('hidden')
    })
}